import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { Mutex } from 'async-mutex'
import { logout } from '../slice/userSlice'
import { reset } from '../slice/authSlice'
import { toast } from 'react-toastify'

// Create a new mutex
const mutex = new Mutex()

const baseOpwUrl = `${process.env.REACT_APP_OPW_SERVICE_API_ENDPOINT}/`

const customOpwFetchBase: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const queryBase = fetchBaseQuery({
    baseUrl: baseOpwUrl, // Use a single base URL
    credentials: 'include', // Include credentials (cookies) in all requests
  })

  await mutex.waitForUnlock()

  let result = await queryBase(args, api, extraOptions)

  const isUnauthorized =
    result.error?.status === 401 ||
    result.error?.status === 403 ||
    (result.error?.data as any)?.message === 'You are not logged in'

  const isLoginRequest =
    typeof args === 'string' ? args.includes('auth/login') : args.url?.includes('auth/login')

  if (isUnauthorized && !isLoginRequest) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire()

      try {
        const refreshResult = await queryBase(
          { credentials: 'include', url: 'auth/refresh' },
          api,
          extraOptions,
        )

        if (refreshResult.data) {
          result = await queryBase(args, api, extraOptions) // Retry the initial query
        } else {
          toast.error('Session Expired Please Login Again.', {
            toastId: 'session-expired',
          })
          api.dispatch(reset())
          api.dispatch(logout())

          localStorage.clear()
          sessionStorage.clear()
          document.cookie.split(';').forEach((cookie) => {
            document.cookie = cookie
              .replace(/^ +/, '')
              .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/')
          })

          window.location.href = '/login'
        }
      } finally {
        release()
      }
    } else {
      await mutex.waitForUnlock()
      result = await queryBase(args, api, extraOptions)
    }
  }

  return result
}

export default customOpwFetchBase
